(() => {
  function initialize(root) {
    if (root.dataset.dtdReady) return;
    root.dataset.dtdReady = 'true';
    const animation = root.querySelector('[data-dtd-animation]');
    const toggle = root.querySelector('[data-dtd-preview-toggle]');
    if (animation && toggle) {
      const poster = animation.getAttribute('src');
      let timer;
      const stop = () => {
        clearTimeout(timer);
        animation.src = poster;
        toggle.setAttribute('aria-pressed', 'false');
        toggle.textContent = 'Play the 26-second preview ▶';
      };
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-pressed') === 'true') { stop(); return; }
        const previewSource = new URL(animation.dataset.animationSrc, window.location.href);
        previewSource.searchParams.set('play', String(Date.now()));
        animation.src = previewSource.href;
        toggle.setAttribute('aria-pressed', 'true');
        toggle.textContent = 'Stop preview ■';
        timer = setTimeout(stop, 26500);
      });
    }
    const select = root.querySelector('[data-dtd-variant]');
    if (!select) return;
    const update = () => {
      const option = select.selectedOptions[0];
      const button = root.querySelector('[data-dtd-buy]');
      const compare = root.querySelector('[data-dtd-compare]');
      root.querySelector('[data-dtd-price]').textContent = option.dataset.price;
      compare.textContent = option.dataset.compare;
      compare.hidden = option.dataset.onSale !== 'true';
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? 'Currently unavailable' : button.dataset.label;
    };
    select.addEventListener('change', update);
    update();
  }
  document.querySelectorAll('[data-dtd-root]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-dtd-root]').forEach(initialize);
  });
})();
